/**
 * Sms list
 */
export const SMS_MESSAGES_FETCH_REQUESTED = 'SMS_MESSAGES_FETCH_REQUESTED'
export const SMS_MESSAGES_FETCH_REQUEST_SUCCESS =
  'SMS_MESSAGES_FETCH_REQUEST_SUCCESS'
export const SMS_MESSAGES_FETCH_REQUEST_ERROR =
  'SMS_MESSAGES_FETCH_REQUEST_ERROR'
export const SMS_SET_FILTERS = 'SMS_SET_FILTERS'

export const SMS_FETCH_MORE_REQUESTED = 'SMS_FETCH_MORE_REQUESTED'
export const SMS_FETCH_MORE_REQUEST_SUCCESS = 'SMS_FETCH_MORE_REQUEST_SUCCESS'
export const SMS_FETCH_MORE_REQUEST_ERROR = 'SMS_FETCH_MORE_REQUEST_ERROR'

export const SMS_FETCH_NEW_SILENTLY_REQUESTED =
  'SMS_FETCH_NEW_SILENTLY_REQUESTED'
export const SMS_FETCH_NEW_SILENTLY_SUCCESS = 'SMS_FETCH_NEW_SILENTLY_SUCCESS'

export const SMS_UPDATE_SECTION = 'SMS_UPDATE_SECTION'

export const SMS_REMOVE_FROM_LIST = 'SMS_REMOVE_FROM_LIST'

/**
 * Marking action
 */
export const SMS_SET_MARKED_FOR_ACTION = 'SMS_SET_MARKED_FOR_ACTION'
export const SMS_RESET_MARKED_FOR_ACTION = 'SMS_RESET_MARKED_FOR_ACTION'

export const SMS_SET_HANDLED_BY_REQUESTED = 'SMS_SET_HANDLED_BY_REQUESTED'
export const SMS_SET_HANDLED_BY_SUCCESS = 'SMS_SET_HANDLED_BY_SUCCESS'

export const SMS_REMOVE_HANDLED_BY_REQUESTED = 'SMS_REMOVE_HANDLED_BY_REQUESTED'
export const SMS_REMOVE_HANDLED_BY_SUCCESS = 'SMS_REMOVE_HANDLED_BY_SUCCESS'

/**
 * Single sms
 */
export const SMS_SET_CURRENT = 'SMS_SET_CURRENT'
export const SMS_RESET_CURRENT = 'SMS_RESET_CURRENT'

export const SMS_FETCH_REQUEST_SUCCESS = 'SMS_FETCH_REQUEST_SUCCESS'
export const SMS_FETCH_REQUEST_ERROR = 'SMS_FETCH_REQUEST_ERROR'

export const SMS_SET_ADDED_LABELS_REQUESTED = 'SMS_SET_ADDED_LABELS_REQUESTED'
export const SMS_SET_ADDED_LABELS_SUCCESS = 'SMS_SET_ADDED_LABELS_SUCCESS'

export const SMS_SET_SINGLE_LIST_ACTION_ID = 'SMS_SET_SINGLE_LIST_ACTION_ID'

export const SMS_FETCH_SILENT_REQUESTED = 'SMS_FETCH_SILENT_REQUESTED'
export const SMS_FETCH_SILENT_SUCCESS = 'SMS_FETCH_SILENT_SUCCESS'
export const SMS_FETCH_SILENT_ERROR = 'SMS_FETCH_SILENT_ERROR'

/**
 * Single and marked sms
 */
export const SMS_DELETE_REQUESTED = 'SMS_DELETE_REQUESTED'
export const SMS_DELETE_SUCCESS = 'SMS_DELETE_SUCCESS'
export const SMS_DELETE_ERROR = 'SMS_DELETE_ERROR'
export const SMS_DELETESTATUS_RESET = 'SMS_DELETESTATUS_RESET'

export const SMS_RESTORE_REQUESTED = 'SMS_RESTORE_REQUESTED'
export const SMS_RESTORE_SUCCESS = 'SMS_RESTORE_SUCCESS'

export const SMS_SET_LABELS = 'SMS_SET_LABELS'
export const SMS_REMOVE_LABEL = 'SMS_REMOVE_LABEL'

export const SMS_UPDATE_DRAFT = 'SMS_UPDATE_DRAFT'
